import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getSubscriptionPayments = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/subscription-payments/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Subscription payments fetch error:", error);
    throw error;
  }
};

const getCurrentSubscription = async (params) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/subscription-payments/current-subscription/`,
      {
        params,
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Current subscription fetch error:", error);
    throw error;
  }
};

const createSubscriptionPayment = async (formData) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/subscription-payments/`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Subscription payment submit error:", error);
    throw error;
  }
};

const initiateWiPaySubscriptionPayment = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/subscription-payments/wipay/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("WiPay subscription payment initiate error:", error);
    throw error;
  }
};

const resubmitSubscriptionPayment = async (id, formData) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/subscription-payments/?id=${id}`,
      formData,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Subscription payment resubmit error:", error);
    throw error;
  }
};

export {
  getSubscriptionPayments,
  getCurrentSubscription,
  createSubscriptionPayment,
  initiateWiPaySubscriptionPayment,
  resubmitSubscriptionPayment,
};
